import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import { SingingPageService } from '../signing-page/signing-page-service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RoleDetail } from '../signing-page/signing-page.dto';
import { setRecipientData } from 'app/global/get-recipient-data';
import { DeletedAttachment } from 'app/main/pages/events/editor-emitter.dto';
import { FieldData } from 'app/main/pages/edit-template/edit-template.dto';
import { AbstractSigningPageComponent } from '../signing-page/abstract-signing-page.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-sign-document-modal',
  templateUrl: './sign-document-modal.component.html',
  styleUrl: './sign-document-modal.component.scss'
})
export class SignDocumentModalComponent extends AbstractSigningPageComponent implements OnInit, OnDestroy {
  @Input() fields_data: FieldData;
  @Input() signature: string;
  @Input() signature_type: string;
  @Input() third_party_auth_response: null;
  @Input() roleId: number;
  @Input() roleDetail: RoleDetail;
  @Input() deleted_attachments: DeletedAttachment[];
  @Input() isEForm: boolean = false;
  @Input() recipientName: string;
  @Input() document_name: string;
  constructor(
    protected globalService: GlobalService,
    protected singingPage: SingingPageService,
    public modal: NgbActiveModal,
    protected modalService: NgbModal
  ) { super(singingPage, globalService, modalService) }
  public signingLoader: boolean = false;
  private destroyed = new Subject<void>();
  ngOnInit(): void {
    if(!this.isEForm){
      this.roleDetail.recipient = setRecipientData(this.roleDetail.personfields);
    }
    this.loading.pipe(takeUntil(this.destroyed)).subscribe((loading: boolean) => this.signingLoader = loading);
  }

  /**
   * sign the document
   */
  signDocument() {
    this.signingLoader = true;
    this.signTheDocument(this.roleId, this.signature, this.signature_type, this.third_party_auth_response, this.roleDetail, this.deleted_attachments, this.fields_data);
  }

  processTheSign() {
    if (this.isEForm) {
      this.modal.close(true);
    } else {
      this.signDocument();
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

}
